<template>
  <div class="container textEditItem" :class="{ 'textEditItemSelected': isSelect() }">
    <div class="row justify-content-between m-0">
      <div class="col-auto item-name m-0 mb-1">
        <small>{{ itemData.itemName }}</small>
      </div>
      <div class="col-auto p-0">
        <img src="@/assets/acrypro/pencil.svg" @click="editAction" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <form onsubmit="return false;">
          <input
            type="text"
            class="w-100 px-2 text-input"
            id="text"
            placeholder="テキスト入力"
            :value="itemData.textArray[this.$store.state.currentSelectPlateNo]"
            @change="changeText"
          />
        </form>
      </div>
    </div>
    <div class="row justify-content-center mt-1">
      <div class="col-12">
        <select v-model="font" class="w-100 text-input" style="">
          <option v-for="item in this.getFontList()" v-bind:key="item.displayName">
            {{ item.displayName }}
          </option>
        </select>
      </div>
    </div>
    <div class="row justify-content-center mt-1">
      <div class="col-12 d-flex">
        <form onsubmit="return false;" class="mx-0 px-0">
          <input
            class="colorPicker mx-0 px-0"
            style="width: 40px; height: 40px"
            type="color"
            v-model="itemData.color"
          />
        </form>
        <form onsubmit="return false;" style="display: inline-block" class="mx-0 px-0">
          <input
            type="text"
            class="text-input mx-0"
            id="text"
            placeholder="text"
            v-model="color"
            style="width: 85px"
            @change="changeColor"
          />
        </form>
        <img
          src="@/assets/acrypro/font-title-icon.svg"
          style="width: 33px; height: 19px"
          class="align-self-center mx-2"
        />
        <select v-model="itemData.fontSize" class="w-100 text-input" style="width: 70px">
          <option v-for="n in 291" v-bind:key="n">
            {{ n+9 }}
          </option>
        </select>
      </div>
    </div>
    <div class="row justify-content-center mt-1">
      <div class="col-12">
        <div class="text-input d-flex" style="background: white">
          <div class="w-100 h-100 d-flex align-items-center p-0 m-0 justify-content-center" >
            <input
              class="p-0 m-0 form-radio"
              type="radio"
              :name="itemData.id"
              id="radios1"
              value="left"
              style="height: 23px; width: 23px"
              v-model="itemData.align"
            />
            <label
              class="form-check-label"
              style="pointer-events: none;"
              for="radios1"
              ><i class="bi bi-text-left h3"></i
            ></label>
          </div>
          <div class="w-100 h-100 d-flex align-items-center p-0 m-0 justify-content-center" >
            <input
              class="form-radio p-0 m-0"
              type="radio"
              :name="itemData.id"
              id="radios2"
              value="center"
              style="height: 23px; width: 23px"
              v-model="itemData.align"
            />
            <label
              class="form-check-label"
              style="pointer-events: none;"
              for="radios2"
              ><i class="bi bi-text-center h3"></i
            ></label>
          </div>
          <div class="w-100 h-100 d-flex align-items-center p-0 m-0 justify-content-center" >
            <input
              class=" form-radio p-0 m-0"
              type="radio"
              :name="itemData.id"
              id="radios3"
              value="right"
              style="height: 23px; width: 23px"
              v-model="itemData.align"
            />
            <label
              class="form-check-label"
              style="pointer-events: none;"
              for="radios3"
              ><i class="bi bi-text-right h3"></i
            ></label>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex">
          <div class="icon-border me-2 img-fluid cursor-pointer" @click="clockRotation">
            <img src="@/assets/acrypro/left-rotate-icon.svg" class="d-block" style="margin: 3px;" >
          </div>
          <div class="icon-border img-fluid cursor-pointer" @click="counterClockRotation">
            <img src="@/assets/acrypro/right-rotate-icon.svg">
          </div>
        </div>
        <div>
          <img src="@/assets/acrypro/trash-icon.svg" @click="itemDelete" style="margin-top:3px;" class="cursor-pointer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontData from "@/js/FontData.js";
import { EditConfig } from "@/js/Const.js";
import Vue from 'vue'

export default {
  name: "TextEditItem",
  props: ["itemData"],
  data: function () {
    return {
      color: "",
      font: "",
      fontSize: 10,
    };
  },
  created() {
    this.color = this.itemData.color.replace("#", "");
    const fontData = new FontData();
    this.font = fontData.getDisplayName(this.itemData.font);
    this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
  },
  watch: {
    "itemData.textArray": function () {
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    "itemData.color": function () {
      this.color = this.itemData.color.replace("#", "");
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    "itemData.fontSize": function () {
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    font: function () {
      const fontData = new FontData();
      this.itemData.font = fontData.getFamilyName(this.font);
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    
  },
  methods: {
    isSelect() {
      if (!this.$store.state.currentCanvasData) {
        return false;
      }
      return this.$store.state.currentCanvasData.currentItem == this.itemData;
    },

    changeColor() {
      // 正規表現で文字コードをチェック
      var regex = new RegExp(/[a-fA-F0-9]{6}/);
      if (regex.test(this.color)) {
        this.itemData.color = "#" + this.color;
      }
    },
    getFontList() {
      const fontData = new FontData();
      return fontData.getFontList();
    },
    // fontSelect(font){
    //   this.itemData.font = font;
    //   this.itemData.updateText();
    // },
    changeText(e) {
      let index = this.$store.state.currentCanvasData.itemList.findIndex( (element) => element.itemName == this.itemData.itemName );
      // this.itemData.textArray[this.$store.state.currentSelectPlateNo] = e.target.value;
      Vue.set(this.$store.state.currentCanvasData.itemList[index].textArray, this.$store.state.currentSelectPlateNo, e.target.value);
      // this.$store.state.currentCanvasData.itemList[index].textArray[this.$store.state.currentSelectPlateNo] = e.target.value;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 拡大
    zoomOn() {
      if (this.itemData.scale > EditConfig.MaxScale) {
        return;
      }
      this.itemData.scale += 0.1;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 縮小
    zoomOff() {
      if (this.itemData.scale < EditConfig.MinScale) {
        return;
      }
      this.itemData.scale -= 0.1;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 右回り
    clockRotation() {
      this.itemData.rotate -= 5;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 左回り
    counterClockRotation() {
      this.itemData.rotate += 5;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    editAction() {
      this.$store.commit("showInputText", {
        title: "名前を入力",
        value: this.itemData.itemName,
        callback: this.textInputed,
      });
    },
    textInputed(inputText) {
      this.itemData.itemName = inputText;
    },
    // 削除
    itemDelete() {
      if (!this.$store.state.currentCanvasData) {
        return false;
      }
      this.$store.state.currentCanvasData.itemList = this.$store.state.currentCanvasData.itemList.filter(
        (element) => {
          return element.itemName != this.itemData.itemName;
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.textEditItem {
  padding: 8px;
  border-bottom: 1px solid $border-sub-color;
  background-color: $background-gray-color;
}
.textEditItemSelected {
  background-color: #e6e5eb;
}

.item-name{
  color: $text-main-color;
  font-weight: bold;
  padding: 0px;
}


.fontList {
  background-color: rgb(255, 255, 255);
  max-height: 200px;
  border: 2px solid rgb(207, 226, 253);
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  /* height: 765px; */
  overflow-y: scroll;
}
.fontListItem {
  list-style-type: none;
}
.colorPicker {
  width: 20px;
  height: 20px;
  border: none;
  background: none;
}

.item-name-aria {
  width: 140px;
}

.item-name {
  font-size: 15px;
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
}

.color-edit-aria {
  width: 100px;
  font-size: 14px;
  margin-top: 10px;
}

.color-text-form {
  width: 60px;
  height: 18px;
  line-height: 18px;
}

.text-edit-btn {
  width: 23px;
  height: 23px;
}
.text-input {
  height: 40px;
  border: 1px solid $border-sub-color;
}
.form-radio {
}

.icon-border {
  width:40px;
  height:40px;
  background: white;
  border: 1px solid $border-sub-color;
}
</style>
